import { Typography } from '@interstate/components/Typography';
import { useSelector } from 'react-redux';

import * as tradeInsSelectors from '@makemydeal/dr-dash-store/selectors/tradeIns';

export const MultiTradeInHeader = ({ formIndex }: { formIndex: number }) => {
    const vehicleYear = useSelector(tradeInsSelectors.getTradeYear(formIndex));
    const vehicleMake = useSelector(tradeInsSelectors.getTradeMake(formIndex));
    const vehicleModel = useSelector(tradeInsSelectors.getTradeModel(formIndex));
    const vehicleTrim = useSelector(tradeInsSelectors.getTradeTrim(formIndex));
    const vehicleInfo = [vehicleYear, vehicleMake, vehicleModel, vehicleTrim].filter(Boolean).join(' ');

    return (
        <Typography
            variant="anchor-block-md"
            color="base.color.blue.600"
            data-testid={`multi-trade-in-header-${formIndex + 1}`}
            sx={{ textWrap: 'auto' }}
        >
            {`Trade ${formIndex + 1}${vehicleInfo ? `: ${vehicleInfo}` : ''}`}
        </Typography>
    );
};
